import { getStoredWorkspaceId, subscribeStoredWorkspaceId } from '@/shared/utils/workspace';

/** Uma troca de escritório invalida a operação mesmo se a pessoa voltar ao escritório inicial. */
export async function noEscritorioAtual<T>(
  executar: (confirmarContexto: () => void) => Promise<T>,
): Promise<T> {
  const escritorio = getStoredWorkspaceId();
  let mudou = false;
  const cancelarInscricao = subscribeStoredWorkspaceId(() => {
    if (getStoredWorkspaceId() !== escritorio) mudou = true;
  });
  const confirmarContexto = () => {
    if (mudou || getStoredWorkspaceId() !== escritorio) {
      throw new DOMException('O escritório da operação mudou', 'AbortError');
    }
  };
  try {
    const resultado = await executar(confirmarContexto);
    confirmarContexto();
    return resultado;
  } finally {
    cancelarInscricao();
  }
}

export function relancarCancelamento(erro: unknown): void {
  if (typeof erro === 'object' && erro !== null && 'name' in erro && erro.name === 'AbortError')
    throw erro;
}
